import type { ISupplierProductNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createSupplierProductNote,
  updateNote: updateSupplierProductNote,
  deleteNote: deleteSupplierProductNote,
} = makeNoteService<ISupplierProductNote>(
  '/api/supplierproductnotes',
  'supplierProductNote'
)
